'use strict';

exports.__esModule = true;

var _isObject = require('lodash/isObject');

var _isObject2 = _interopRequireDefault(_isObject);

var _Purpose = require('../Purpose');

var _Purpose2 = _interopRequireDefault(_Purpose);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isPurpose = function isPurpose(obj) {
  return (0, _isObject2.default)(obj) && obj instanceof _Purpose2.default;
};

exports.default = isPurpose;


//////////////////
// WEBPACK FOOTER
// ./node_modules/kindergarten/lib/utils/isPurpose.js
// module id = ncd4
// module chunks = 40